export type ApiCallStatus = 'idle' | 'loading' | 'success' | 'error';
export type FileStatus =
  | 'pending'
  | 'validating'
  | 'converting'
  | 'uploading'
  | 'success'
  | 'error';

// ── Interfaces ─────────────────────────────────────────────────────────────

export interface ReviewerBody {
  reviewer_name: string;
  reviewer_email: string;
}

export interface ApproverUser {
  first_name: string;
  last_name?: string;
  email: string;
}

// ── Constants ──────────────────────────────────────────────────────────────

export const REDIRECT_DELAY_MS = 5000;

export const PDF_UPLOAD_PATH = '/doqfy/bulk-upload-estamp/pdf-upload';

export const ORDER_CONFIRMATION_PATH =
  '/doqfy/bulk-upload-estamp/order-confirmation';

export const SESSION_KEYS = {
  sessionUuid: 'sessionUuid',
  excelValidationData: 'excelValidationData',
  presignedUrlsData: 'presignedUrlsData',
  excelConvertedData: 'excelConvertedData'
} as const;

export const IN_PROGRESS_STATUSES: FileStatus[] = [
  'pending',
  'validating',
  'converting',
  'uploading'
];

// ── Status Maps ────────────────────────────────────────────────────────────

export const FILE_STATUS_TEXT: Record<FileStatus, string> = {
  pending: 'Pending',
  validating: 'Validating PDF',
  converting: 'Converting to Base64',
  uploading: 'Uploading to Server',
  success: 'Upload Complete',
  error: 'Upload Failed'
};

export const FILE_STATUS_ICON: Record<FileStatus, string> = {
  pending: 'pi pi-clock',
  validating: 'pi pi-spin pi-spinner',
  converting: 'pi pi-spin pi-spinner',
  uploading: 'pi pi-spin pi-spinner',
  success: 'pi pi-check-circle',
  error: 'pi pi-times-circle'
};

export const FILE_STATUS_COLOR: Record<FileStatus, string> = {
  pending: '#6c757d',
  validating: '#ffc107',
  converting: '#17a2b8',
  uploading: '#007bff',
  success: '#28a745',
  error: '#dc3545'
};
